/**
 * Country Configuration
 * This file is auto-generated based on the COUNTRY environment variable
 * Uses countries.json to map to native language name
 * 
 * Generated at: 2026-03-30T14:08:32.078Z
 */

// Country name in native language (mapped from COUNTRY env var)
export const COUNTRY = 'Canada'

// Original country name from environment variable
export const COUNTRY_ENGLISH = 'Canada'

// Get country name in native language
export function getCountryName() {
  return COUNTRY
}

// Get original English country name
export function getCountryNameEnglish() {
  return COUNTRY_ENGLISH
}

export default COUNTRY
